// extracted by mini-css-extract-plugin
export default {"dialog":"VbUg2n2m0kgYOSQ3","body":"aUoxO5yKoFfxaaWS","header":"otksH2wyStItGyly","title":"vcOafjkanQ90uvGI","subTitle":"PtFv3lyd6slZzylS"};